module.exports = __webpack_public_path__ + "static/media/aamala.6a02efd6.png";